import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
    palette : {
        primary : {
            main  : '#008675',
            light : '#61DEBF',
            dark  : '#007C62'
        },
        secondary : {
            main : '#008675', //#f50057, #2196f3
            light: '#61DEBF', //#f73378, #90caf9
            dark : '#007C62', //#ab003c, #0d47a1
        },
        action : {
            //selected: 'rgba(240, 230, 255, 0.65)'
            //selected: 'rgba(0, 179, 179, 0.3)'
        },
        error: {
            main: '#ab2109'
        }
    },
    typography : {
        useNextVariants : true,
        fontFamily: 'Open Sans, sans-serif',
    },
    shape: {
        borderRadius: 0,
    }
});

export default theme;